import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { CONTACT } from '../mock';

export default function LocationSEO() {
  const keywords = ['counseling in Chesapeake VA','therapist in Chesapeake VA','trauma therapy','EMDR therapy','anxiety therapy','couples counseling','women’s counseling','telehealth therapy Virginia','Hampton Roads counseling'];
  return (
    <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 items-start">
        <div className="reveal">
          <div className="eyebrow mb-3">Local to Hampton Roads</div>
          <h2 className="section-title mb-5">Counseling in <span className="text-[color:var(--dusty-rose)]">Chesapeake, Virginia</span></h2>
          <p className="text-[color:var(--taupe-gray)] leading-relaxed mb-6">
            We proudly serve Chesapeake, Virginia Beach, Norfolk, Suffolk, Portsmouth, and the greater Hampton Roads area — both in person and through secure telehealth throughout Virginia.
          </p>

          <div className="space-y-4 mb-8">
            <div className="flex gap-3"><MapPin className="w-5 h-5 text-[color:var(--dusty-rose)] mt-0.5" /><div><div className="font-semibold text-[color:var(--deep-sage)]">{CONTACT.name}</div><div className="text-sm text-[color:var(--taupe-gray)]">{CONTACT.address}, {CONTACT.city}</div></div></div>
            <div className="flex gap-3"><Phone className="w-5 h-5 text-[color:var(--dusty-rose)] mt-0.5" /><a href={CONTACT.phoneHref} className="text-[color:var(--deep-sage)] hover:text-[color:var(--dusty-rose)]">{CONTACT.phone}</a></div>
            <div className="flex gap-3"><Mail className="w-5 h-5 text-[color:var(--dusty-rose)] mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="text-[color:var(--deep-sage)] hover:text-[color:var(--dusty-rose)] break-all">{CONTACT.email}</a></div>
          </div>

          <div className="flex flex-wrap gap-2">
            {keywords.map(k => (
              <span key={k} className="text-xs px-3 py-1.5 rounded-full text-[color:var(--sage-dark)]" style={{ background: 'rgba(184,190,164,0.25)' }}>{k}</span>
            ))}
          </div>
        </div>

        <div className="reveal card-soft overflow-hidden">
          <iframe
            title="Chesapeake Counseling Center location"
            src="https://www.google.com/maps?q=501+Cedar+Rd+Chesapeake+VA+23322&output=embed"
            width="100%"
            height="420"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
